import { useContext, useEffect, useMemo, useState } from 'react';
import { SmartSendContext } from '~/apps/smartsend/lib/context/SmartSendContext';
import useExternalSearch from '../../smartsend/client/useExternalSearch';
import { SmartSendSubType } from '~/apps/smartsend/lib/consts/SmartSendSubType';
import { ExternalSearchInTransit } from '~/apps/smartsend/lib/consts/ListyConsts';

export const useSmartNavigationData = () => {
  const ctx = useContext(SmartSendContext);
  const { getExternalSearchQueryCountByListyKey } = useExternalSearch();
  const [data, setData] = useState({
    inTransitCount: 0
  });

  // Sold
  const soldCount = useMemo(() => {
    return (ctx.state.filters[SmartSendSubType].summary.stats.find((x) => x.key === 'Sold')?.value as number) || 0;
  }, [ctx.state]);

  // In Transit
  useEffect(() => {
    const fetchInTransitCount = async () => {
      try {
        const count = await getExternalSearchQueryCountByListyKey(ExternalSearchInTransit);
        setData((prev) => ({ ...prev, inTransitCount: count }));
      } catch (error) {
        console.error('Error fetching In Transit count:', error);
      }
    };
    fetchInTransitCount();
    const interval = setInterval(fetchInTransitCount, 60000);
    return () => clearInterval(interval);
  }, [getExternalSearchQueryCountByListyKey]);

  return { ...data, soldCount: soldCount };
};
